import React from 'react';
import { Spinner as ReactSpinner } from 'react-bootstrap';
import './LoadingOverlay.css';

interface Props {
  children: any;
  loading: boolean;
}

const LoadingOverlay = ({ children, loading }: Props) => {
  if (!loading) {
    return children;
  }

  return (
    <div className='loader-wrapper'>
      <div className='loader-overlay' />
      <ReactSpinner className='loader-spinner' animation='border' role='status'>
        <span className='visually-hidden'>Loading...</span>
      </ReactSpinner>

      {children}
    </div>
  );
};

export default LoadingOverlay;
